// import { createTheme, ThemeProvider } from '@material-ui/core';
import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import CustomToolbar from '../../../CommonComponents/CustomToolbar'
import MUIDataTable from 'mui-datatables';
import TourServices from '../../Invoice/TourServices';
import { ThemeProvider, createTheme } from '@mui/material';
import withRouter from '../../../withRouter';
import Footer from '../../../Component/Footer';
import Header from '../../../Component/Header';
import Menu from '../../../Component/Menu';


const theme = createTheme({
  overrides: {
    MuiTableCell: {
      head: {
        backgroundColor: "#e9ecef !important",
        border: [[1, "solid", "#ece6e6"]],
      },
      body: {
        border: [[1, "solid", "#ece6e6"]],
      },
    },
  },
});


const MAirlineList = () => {
  const[airline,setAirline]=useState([]);

  useEffect(() => {
    console.log("Hie sayeem")
    getMAirlineList();
  },[])

  const delteDataHandler = (e) => {
    console.log(e,"iddd");
    if (confirm('Are you sure you want to delete this thing into the database?')) {
      TourServices.deleteMAirline(e).then((r) => {
        console.log(r.data);
        getMAirlineList();
        console.log('Thing was Deleted from database.');
      })
    } else {
      
      console.log('Thing was not Deleted from the database.');
    }
   
  }

  const getMAirlineList = () => {
    TourServices.getAllMAirlineList().then(res=>setAirline(res.data))
    
  }
  const columns = [
    {
      name: "id",
      label: "ID",
      options: { filter: true, sort: true },
    },
    {
      name: "chrcode",
      label: "Chr. Code",
      options: { filter: true, sort: true },
    },
    {
      name: "airlinename",
      label: "Airline Name",
      options: { filter: true, sort: true },
    },
    {
      name: "numericcode",
      label: "Airline Code",
      options: { filter: true, sort: true },
    },
    {
      name: "airlineaddress",
      label: "Airline Address",
      options: { filter: true, sort: true },
    },
    {
      name: "airlinevatno",
      label: "Airline Vat No.",
      options: { filter: true, sort: true },
    },
    {
      name: "country",
      label: "Country",
      options: { filter: true, sort: true },
    },
    {
      name: "currency",
      label: "Currency",
      options: { filter: true, sort: true },
    },


    {
      name: "Action",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <button
                as="button"
                data-tip
                data-for="delete"
                className="btn btn-sm deletebutton"
                to={{ state: { id: tableMeta.rowData.find(e => e), pagename: "MAirline" } }}
                onClick={() =>
                  delteDataHandler(tableMeta.rowData.find(e => e))
                }
              >Delete</button>

              <Link as="button" className="btn btn-sm hovbuttonColour mr-2"
                to={{ pathname: "/masterairline" }} state={{ id: tableMeta.rowData.find(e => e), pagename: "Edit Airline" }}>Edit</Link>
              <br />
            </>
          );
        },
      },
    },
  ];

  const options = {
    filterType: "checkbox",
    selectableRows: "none",
    customToolbar: () => {
      return (
        <>
          (
          <Link
            as="button"
            className="float-right btn btn-sm m-0 p-0"
            to={{ pathname: "/masterairline" }}
            state={{ id: -1, pagename: "Add Airline" }}
          >
            <CustomToolbar />
          </Link>
          )
        </>
      );
    },
  };

  return (
    <>
      <Header />
      <Menu />
      <div className="content-wrapper w-100% h-100%">
        <div className="card">
          <ol className="breadcrumb float-sm-right">
          <span
                as="button"
                className=" text-secondary cursorPointer"
                
              >
                <Link to="/masterpage" style={{color:"grey"}}>❮ Back &nbsp;&nbsp;</Link>
                
              </span>
            <li className="breadcrumb-item text-secondary">
              <Link to="/index">Home</Link>
            </li>
            <li className="breadcrumb-item text-secondary">
              <Link to="/masterpage">Tours & Travellers </Link>
            </li>
            <li className="breadcrumb-item active">Master Airline</li>
          </ol>
          <div className='card'>
            <div className='card-body'>

              <ThemeProvider theme={theme}>
                <MUIDataTable
                  className="table-sm px-3"
                  title={"Airline List"} 
                  data={airline}
                  columns={columns}
                  options={options}
                />
              </ThemeProvider>
            </div>
          </div>
        </div>
      </div>
      <Footer />

    </>
  )
}

export default withRouter(MAirlineList);